module.exports = __webpack_public_path__ + "static/media/mailbox-dark.2512d9e7.svg";